var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "5 0 90 90",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a3a3a3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 30.5H25c-5 0-9 4-9 9v43c0 5 4 9 9 9h50c5 0 9-4 9-9v-43c0-5-4-9-9-9zM64.301 54.801c0 1.7-1.3 3-3 3H38.699c-1.7 0-3-1.3-3-3v-7.602c0-1.699 1.3-3 3-3s3 1.301 3 3v4.602h16.602v-4.602c0-1.699 1.3-3 3-3s3 1.301 3 3zM25 25.5h50c1.7 0 3-1.3 3-3s-1.3-3-3-3H25c-1.7 0-3 1.3-3 3s1.3 3 3 3zM30 14.5h40c1.7 0 3-1.3 3-3s-1.3-3-3-3H30c-1.7 0-3 1.3-3 3s1.3 3 3 3z"
  }))));
}
export default SvgArchiveGrey;